export const grossToNet = (gross: number, taxRate: number) => gross / (1 + taxRate)

export const netToGross = (net: number, taxRate: number) => net * (1 + taxRate)

export const getTaxRateFromNetAndGross = (net: number, gross: number) => gross / net - 1
